import utils from 'utils'
class taskTraceCtrl {
  constructor(
    $scope,
    logger,
    httpRequest,
    initSortService,
    globalFn,
    $filter,
    $uibModal,
    sweetalert
  ) {
    $scope.currentUserInfo = JSON.parse(localStorage.user_info).user;
    $scope.select = {}
    $scope.treeConfig = {
        isCheckall: true,
        check: {
            //如果没有设置配置项，取默认配置
            enable: true, //显示不显示复选框
            chkboxType: { Y: '', N: '' },
        },
    }
    // 所勾选初始的数据
    $scope.selectedRows = []
    // 改变税款所属月份
    $scope.updateSearch = function () {
      queryInfo()
    }
    $scope.param = {
      pageNum: 1,
      pageSize: 10,
      param: {
        quarter: utils.getQuarter(),
        companyName: '',
        creditCode: '',
        declarationFillInStatus: '',
        declarationStatus: '',
        departmentNo: '',
        managerCityNo: '',
        paymentStatus: '',
        regionNo: '',
        status: '1',
        reportGenerationStatus: '',
      },
    }
    // 重置
    $scope.reset = function () {
      $scope.param.param = {
        quarter: utils.getQuarter(),
        companyName: '',
        creditCode: '',
        declarationFillInStatus: '',
        declarationStatus: '',
        departmentNo: '',
        managerCityNo: '',
        paymentStatus: '',
        regionNo: '',
        status: '1',
        reportGenerationStatus: '',
      }
    //   queryInfo()
    getUserInfo()
    }
    // 监听所勾选纳税人变化
    $scope.$watch(
      'selectedRows',
      (newVal, oldVal) => {
        //纳税人数
        $scope.taxPayerNum = newVal.length
        // 合计
        $scope.taxPayerAmount = 0
        angular.forEach(newVal, (item, index) => {
          $scope.taxPayerAmount = globalFn.Add($scope.taxPayerAmount, item.currentTaxRefund)
        })
      },
      true
    )

    // 字典数据
    $scope.dictData = {}
    const typecodeArr = [
      'enterprise_generationStatus', //生成状态
      'enterprise_fillInStatus', //申报表填入状态
      'enterprise_declaration', //申报状态
      'payment_status', //缴款状态
      'department_no', //事业部
      'zzs_status',
      'submission_status',
      'accounting_standard',
      'tax_status',
      'yes_no_flag',
    ]
    httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
      $scope.dictData = $.extend($scope.dictData, res.data.value)
    })
    // 主管税局省（市）
    httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
      $scope.dictDataProvince = res.data.value
    })
    // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value
    })
    // 获取管理城市时两个都要传
    $scope.$watch('param.param.regionNo', function (newVal, oldVal) {
      //重置
      if ($scope.param.param.regionName == '') {
        $scope.belleRegionCityList = []
        return
      }
      let params = {
        affiliation: $scope.param.param.departmentNo,
        regionNo: $scope.param.param.regionNo,
      }
      if (params.affiliation == '' || params.regionNo == '') return
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value
      })
    })

    // 发票采集
    $scope.invoiceCollection = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      // if (isEnable()) {
      //   logger.logError('纳税人被禁用不允许申报表填入/申报/缴款，请检查！')
      //   return
      // }
      try {
        angular.forEach($scope.selectedRows, function (item, index) {
          if (Number(item.fillInStatus) == 1) {
            logger.logError('RPA正在准备填入申报表，不允许发票采集，请检查')
            throw new Error(true)
          }
          if (Number(item.fillInStatus) == 2 || Number(item.fillInStatus) == 3) {
            logger.logError('申报表已填入成功，不允许再发票采集，请检查')
            throw new Error(true)
          }
        })
      } catch (e) {
        if (e) {
          return
        }
      }
      // 未填入和填入失败采集
      $scope.showCollectionDetailDialog($scope.selectedRows)
    }
    // 打开发票采集弹窗
    $scope.showCollectionDetailDialog = function (data) {
      return $uibModal.open({
        templateUrl: 'collectionDetai.html',
        controller: [
          '$scope',
          '$uibModalInstance',
          'logger',
          'items1',
          function ($scope, $uibModalInstance, logger, items1) {
            $scope.ok = () => {
              const selectedRowIdList = []
              angular.forEach(data, function (item, index, array) {
                selectedRowIdList.push(item.id)
              })
              // let mapArr = selectedRowIdList.map(String)
              // let params = {
              //   ids: mapArr,
              // }
              httpRequest.post_sbTrackCollection(selectedRowIdList, false).then((res) => {
                if (res.data.msgCode == 90017) {
                  logger.logError(res.data.message)
                  return
                } else if (res.data.msgCode == 90018) {
                  logger.logError(res.data.message)
                  return
                }
                logger.logSuccess('数据采集成功，请等待RPA操作')
                queryInfo()
              })
              $uibModalInstance.close()
            }
            $scope.cancel = () => {
              $uibModalInstance.dismiss()
            }
          },
        ],
        backdrop: 'static',
        openedClass: 'mod-modal mod-modal-md',
        resolve: {
          items1() {},
        },
      }).result
    }
    //申报表填入
    $scope.declarationFill = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      // if (isEnable()) {
      //   logger.logError('纳税人被禁用不允许申报表填入，请检查！')
      //   return
      // }
      const selectedRowIdList = []
      angular.forEach($scope.selectedRows, function (item, index, array) {
        selectedRowIdList.push(item.id)
      })
      let declareMapArr = selectedRowIdList.map(String)
      httpRequest.post_enterpriseTaxDeclareFillIn(declareMapArr, false).then((res) => {
        let declareData = res.data.value
        if (declareData.length > 0) {
          logger.logError(declareData[0].message)
        } else {
          logger.logSuccess('申报表填入成功，请等待RPA操作。')
          queryInfo()
        }
      })
    }
    //申报
    $scope.declare = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      // 后端做了校验 也可一起做
      if (isEnable()) {
        logger.logError('纳税人被禁用不允许申报，请检查！')
        return
      }
      const selectedRowIdList = []
      try {
        angular.forEach($scope.selectedRows, function (item, index, array) {
          if (
            (item.declarationFillInStatus == 0 || item.declarationFillInStatus == 4) &&
            (item.declarationStatus == 0 || item.declarationStatus == 4)
          ) {
            selectedRowIdList.push(item.id)
            throw new Error(true)
          } else {
            selectedRowIdList.push(item.id)
          }
        })
      } catch (e) {
        if (e) {
          let declareMapArr = selectedRowIdList.map(String)
          sweetalert
            .confirm(
              '操作提醒',
              '申报数据未填入或填入失败，请确认是否已在税局平台人工报送。确认已人工报送点击【确认】进入【申报】环节，反之则点击【取消】。'
            )
            .then(() => {
              httpRequest
                .post_enterpriseTaxDeclare(
                  JSON.stringify(declareMapArr),
                  '申报成功，请等待RPA操作。'
                )
                .then((res) => {
                  queryInfo()
                  // 重置
                  $scope.selectedRows = []
                })
            })
          return
        }
      }
      let declareMapArr = selectedRowIdList.map(String)
      httpRequest.post_enterpriseTaxDeclare(declareMapArr, false).then((res) => {
        let declareData = res.data.value
        if (declareData.length > 0) {
          logger.logError(declareData[0].message)
        } else {
          logger.logSuccess('申报成功，请等待RPA操作。')
          queryInfo()
        }
      })
    }
    //交款
    $scope.Pay = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      // if (isEnable()) {
      //   logger.logError('纳税人被禁用不允许申报表缴款，请检查！')
      //   return
      // }
      let selectedRowIdList = []
      // 提示文案id集合
      let selectedRowIdLists = []
      angular.forEach($scope.selectedRows, function (item, index, array) {
        if (
          (item.declarationFillInStatus == 2 || item.declarationFillInStatus == 3) &&
          (item.declarationStatus == 0 || item.declarationStatus == 4) &&
          (item.paymentStatus == 0 || item.paymentStatus == 4)
        ) {
          selectedRowIdLists.push(item.id)
        } else {
          selectedRowIdList.push(item.id)
        }
      })
      let PayIdArr = selectedRowIdList.map(String)
      let PayIdArrs = selectedRowIdLists.map(String)
      if (selectedRowIdLists.length > 0) {
        sweetalert
          .confirm(
            '操作提醒',
            '申报状态为未申报或申报失败，请确认是否已在税局平台人工报送。确认已人工报送点击【确认】进入【缴款】环节，反之则点击【取消】。'
          )
          .then(() => {
            httpRequest
              .post_enterpriseTaxPayment(JSON.stringify(PayIdArrs), '缴款成功，请等待RPA操作。')
              .then((res) => {
                queryInfo()
                // 重置
                $scope.selectedRows = []
              })
          })
        return
      }
      httpRequest.post_enterpriseTaxPayment(PayIdArr, false).then((res) => {
        let batchPayData = res.data.value
        if (batchPayData.length > 0) {
          logger.logError(batchPayData[0].message)
        } else {
          logger.logSuccess('缴款成功，请等待RPA操作。')
          queryInfo()
        }
      })
    }
    function isEnable() {
      let arrBoolean = $scope.selectedRows.some((res) => {
        return res.status == 0
      })
      return arrBoolean
    }
    // 查询展开
    $scope.isFilterCollapsed = false
    $scope.customizedConfig = {
      version: 5.5,
      queryConfig: [
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '申报表生成状态',
          selected: true,
          default: true,
        },
        {
          label: '申报表填入状态',
          selected: true,
          default: true,
        },
        {
          label: '申报状态',
          selected: true,
          default: true,
        },
        {
          label: '缴款状态',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属大区',
          selected: false,
          default: false,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '主管税局所在省市',
          selected: false,
          default: false,
        },
        {
          label: '是否开启申报',
          selected: true,
          default: true,
        },
        {
          label: '财务报表导入状态',
          selected: true,
          default: true,
        },
        {
          label: '财务报表报送状态',
          selected: true,
          default: true,
        },
        {
          label: '财务报表适用会计准则',
          selected: true,
          default: true,
        },
        {
          label: '所得税申报须先报财务报表否',
          selected: true,
          default: true,
        },
        {
          label: '是否变更缴款状态',
          selected: false,
          default: false,
        },
        {
          label: '跟进人',
          selected: false,
          default: false,
        },
      ],
      table: [
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '申报表生成状态',
          selected: true,
          default: true,
        },
        {
          label: '申报表填入状态',
          selected: true,
          default: true,
        },
        {
          label: '申报状态',
          selected: true,
          default: true,
        },
        {
          label: '缴款状态',
          selected: true,
          default: true,
        },
        {
          label: '税局异常信息提示',
          selected: false,
          default: false,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属大区',
          selected: false,
          default: false,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '主管税局所在省市',
          selected: false,
          default: false,
        },
        {
          label: '营业收入',
          selected: true,
          default: true,
        },
        {
          label: '营业成本',
          selected: true,
          default: true,
        },
        {
          label: '利润总额',
          selected: true,
          default: true,
        },
        {
          label: '分支机构本期分摊应补(退)所得税额',
          selected: false,
          default: false,
        },
        {
          label: '分支机构本期分摊比例',
          selected: false,
          default: false,
        },
        {
          label: `本期应补(退)所得税额(12-13-14-15)${decodeURI(
            '%5C'
          )}税务机关确定的本期应纳所得税额`,
          selected: true,
          default: true,
        },
        {
          label: '是否开启申报',
          selected: true,
          default: true,
        },
        {
          label: '财务报表导入状态',
          selected: true,
          default: true,
        },
        {
          label: '财务报表报送状态',
          selected: true,
          default: true,
        },
        {
          label: '财务报表异常信息提示',
          selected: true,
          default: true,
        },
        {
          label: '财务报表适用会计准则',
          selected: true,
          default: true,
        },
        {
          label: '所得税申报须先报财务报表否',
          selected: true,
          default: true,
        },
        {
          label: '是否变更缴款状态',
          selected: false,
          default: false,
        },
        {
            label: '跟进人',
            selected: false,
            default: false,
        },
      ],
    }
    $scope.currentPage = 1 // 设置显示第一页
    $scope.maxSize = 10 // 每一叶显示记录数

    $scope.pageChanged = function () {
      // 点击页码发起查询
      queryInfo()
    }

    function queryInfo() {
      const openLoading =
        $scope.param.pageSize >= 100
          ? window.layer.msg('正在查询，请耐心等待', {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            })
          : null
      httpRequest
        .post_getEnterpriseTaskList(queryDataHandle($scope.param))
        .then((res) => {
          $scope.listData = res.data.value.list
          // 获取后台分页数据 回写分页组件
          $scope.totalItems = res.data.value.total
          $scope.param.pageNum = res.data.value.pageNum
          $scope.currentPage = ++res.data.value.prePage
          $scope.param.pageSize = res.data.value.pageSize
        })
        .finally(() => {
          window.layer.close(openLoading)
        })
    }
    function queryDataHandle(queryData) {
        $scope.employeeList = []
        const { selectedFollower } = $scope.select
        selectedFollower.forEach(item => {
            $scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
        });
        queryData.param.employeeList = $scope.employeeList

        return queryData
    }
    // queryInfo()

    $scope.searchlist = function () {
      queryInfo()
    }
    //导出
    $scope.exportExel = function exportExel() {
      let fileName = '申报任务跟踪(企业所得税)_' + $scope.param.param.quarter
      let url = `${
        host.etcloudIvatApp
      }taxdeclaration/rpaGsTask/exportList?accessToken=${localStorage.getItem('id_token')}`
      utils.file_download(
        url,
        $scope.param.param,
        'enterprise_task', //type
        'POST',
        'blob',
        fileName,
        false
      )
    }
    // 还原
    $scope.reduction = (type) => {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选择数据后操作')
      }
      try {
        angular.forEach($scope.selectedRows, (item, index) => {
          if (!incomeTaxDeclaration[item.submissionStatuss].verifyMapper(item)) {
            throw new Error('break')
          }
          //   if (item.declarationStatus == 2 || item.declarationStatus == 3) {
          //     logger.logError('申报已成功，不允许还原，请检查。');
          //     throw new Error('break');
          //   }
        })
      } catch (e) {
        return
      }
      let params = {
        ids: [],
        type,
      }
      for (let i = 0; i < $scope.selectedRows.length; i++) {
        params.ids.push($scope.selectedRows[i].id)
      }
      sweetalert
        .confirm(
          '还原提示',
          '确认需要对选择的数据进行还原操作，确认请点击【确定】按钮，否则点击【取消】按钮。'
        )
        .then(() => {
          httpRequest.post_reductionStatus(params).then((res) => {
            logger.logSuccess('还原成功')
            queryInfo()
          })
        })
    }
    //还原校验
    const incomeTaxDeclaration = {
      0: {
        verifyMapper(obj) {
          // 校验<申报状态>
          if (
            (obj.declarationStatus == 2 || obj.declarationStatus == 3) &&
            (obj.financeFillInStatus == 2 || obj.financeFillInStatus == 3)
          ) {
            logger.logError('财务报表及申报表已报送成功，不允许还原，请检查。')
            return false
          }
          return true
        },
      },
      //是
      1: {
        verifyMapper(obj) {
          //校验<财务报表报送状态>
          if (
            (obj.financeFillInStatus == 0 ||
              obj.financeFillInStatus == 1 ||
              obj.financeFillInStatus == 4) &&
            (obj.declarationStatus == 2 || obj.declarationStatus == 3)
          ) {
            logger.logError('申报表已报送成功，不允许还原，请检查。')
            return false
          }
          if (
            (obj.financeFillInStatus == 2 || obj.financeFillInStatus == 3) &&
            (obj.declarationStatus == 2 || obj.declarationStatus == 3)
          ) {
            logger.logError('财务报表及申报表已报送成功，不允许还原，请检查。')
            return false
          }
          return true
        },
      },
    }
    //财务报表填报
    $scope.financialStatements = () => {
      let selectedRowIdList = []
      if (!$scope.selectedRows.length) {
        return logger.logError('请选择数据后操作')
      }
      try {
        angular.forEach($scope.selectedRows, (item, index) => {
          // 校验<财务报表导入状态> 校验的顺序不能变
          if (!$scope.verify_FRIS(item)) {
            throw new Error('break')
          }
          //校验<财务报表报送状态>
          if (!$scope.verify_FSSS(item)) {
            throw new Error('break')
          }
          //   校验<财务报表报送否>
          if (!$scope.verify_SOFS(item)) {
            throw new Error('break')
          }
          selectedRowIdList.push(item.id)
        })
      } catch (e) {
        return
      }
      httpRequest.post_enterpriseTaxCwFillIn(selectedRowIdList.map(String)).then((res) => {
        if (res.data.success) {
          logger.logSuccess('财务报表填报成功')
          queryInfo()
        }
      })
    }
    //财务报表、申报表填入及申报
    $scope.financialStatementsReport = () => {
      let selectedRowIdList = []
      if (!$scope.selectedRows.length) {
        return logger.logError('请选择数据后操作')
      }
      try {
        angular.forEach($scope.selectedRows, (item, index) => {
          // 校验<财务报表导入状态>  校验的顺序不能变
          if (!$scope.verify_FRIS(item)) {
            throw new Error('break')
          }
          //校验<财务报表报送状态>
          if (!$scope.verify_FSSS(item)) {
            throw new Error('break')
          }
          //   校验<申报表生成状态>
          if (!$scope.verify_DFGS(item)) {
            throw new Error('break')
          }
          //   校验<申报表填入状态>
          if (!$scope.verify_FSDF(item)) {
            throw new Error('break')
          }
          //   校验<申报表申报状态>
          if (!$scope.verify_DFDS(item)) {
            throw new Error('break')
          }
          //   校验<财务报表报送否>
          if (!$scope.verify_SOFS(item)) {
            throw new Error('break')
          }
          selectedRowIdList.push(item.id)
        })
      } catch (e) {
        return
      }
      httpRequest
        .post_enterpriseTaxCwDeclareFillIn(
          selectedRowIdList.map(String),
          '财务报表、申报表填入及申报成功'
        )
        .then((res) => {
          queryInfo()
        })
    }
    //  校验<财务报表导入状态>
    $scope.verify_FRIS = (obj) => {
      if (obj.cwbbFillInStatus == 0) {
        logger.logError('财务报表未导入无法启动任务，请检查。')
        return false
      }
      return true
    }
    //  校验<财务报表报送状态>
    $scope.verify_FSSS = (obj) => {
      if (obj.financeFillInStatus == 2 || obj.financeFillInStatus == 3) {
        logger.logError('财务报表已填报成功，请检查。')
        return false
      }
      if (obj.financeFillInStatus == 1) {
        logger.logError('已触发RPA填报财务报表，请等待。')
        return false
      }
      return true
    }
    //  校验<申报表生成状态>
    $scope.verify_DFGS = (obj) => {
      if (obj.reportGenerationStatus == 0) {
        logger.logError(`${obj.taxno}税号申报表未生成，请检查`)
        return false
      }
      return true
    }
    //  校验<申报表填入状态>
    $scope.verify_FSDF = (obj) => {
      if (obj.declarationFillInStatus == 1) {
        logger.logError(`已触发RPA填入所得税报表，请检查。`)
        return false
      }
      if (obj.declarationFillInStatus == 2 || obj.declarationFillInStatus == 3) {
        logger.logError('申报表已填入成功，请检查。')
        return false
      }
      return true
    }
    //  校验<申报表申报状态>
    $scope.verify_DFDS = (obj) => {
      if (obj.declarationStatus == 1) {
        logger.logError(`已触发RPA申报所得税报表，请检查。`)
        return false
      }
      if (obj.declarationStatus == 2 || obj.declarationStatus == 3) {
        logger.logError('申报表已申报成功，请检查。')
        return false
      }
      return true
    }
    //  校验<财务报表报送否>
    $scope.verify_SOFS = (obj) => {
      if (obj.submissionStatus == 0) {
        logger.logError('财务报表报送未开启，请检查。')
        return false
      }
      return true
    }
    $scope.changePaymentStatus = (status) => {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      const idList = $scope.selectedRows.map((item) => item.id).map(String)
      if (Object.is(status, 0)) {
        return httpRequest
          .post_rpaEnterpriseTaxChangeRpaTaskPayment({ idList, status })
          .then((res) => {
            logger.logSuccess('取消变更缴款状态成功')
            setTimeout(() => {
              queryInfo()
            }, 2000)
          })
      }
      sweetalert
        .confirm(
          '变更缴款状态提醒',
          '仅缴款状态为未缴款/缴款失败/待RPA缴款的数据支持变更缴款状态，其余状态的数据将自动过滤，确认需要对选择的数据进行变更缴款状态为“人工缴款成功”吗？'
        )
        .then(() => {
          httpRequest.post_rpaEnterpriseTaxChangeRpaTaskPayment({ idList, status }).then((res) => {
            logger.logSuccess('变更缴款状态成功')
            setTimeout(() => {
              queryInfo()
            }, 2000)
          })
        })
    }
    function getUserInfo() {
        $scope.params = {
            pageSize: 2000,
            pageNum: 1,
            param: {
                isRoleOwner: '1', // 拥有本机构角色
                orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
            },
        }
        httpRequest.get_getIvatEmployeeList().then((res) => {
            $scope.followerList = dataHandle(res.data.value)
            $scope.select.selectedFollower =  $scope.followerList.filter((x) => { return x.employeeName == $scope.currentUserInfo.realName})
            queryInfo()
        })
    }
    getUserInfo()
    function dataHandle(list) {
        list.forEach((el,index) => {
            el.orgId = index
            el.orgName = el.employeeName + '|' + el.employeeNumber
            if ($scope.currentUserInfo.realName == el.employeeName) {
                el.checked = true
            } else {
                el.checked = false
            }
        })
        return list
    }
  }
}
taskTraceCtrl.$inject = [
  '$scope',
  'logger',
  'httpRequest',
  'initSortService',
  'globalFn',
  '$filter',
  '$uibModal',
  'sweetalert',
]
export default taskTraceCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/taskTrace/taskTraceCtrl.js